var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 192,
    viewBox: "0 0 193 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.481 111H29.0001C28.1751 111 27.5001 111.675 27.5001 112.5V123.75C27.5001 124.575 28.1751 125.25 29.0001 125.25H142.475L115.419 159.562C114.65 160.538 115.344 162 116.6 162H130.194C131.113 162 131.975 161.588 132.556 160.856L164.206 120.712C167.3 116.775 164.506 111 159.481 111ZM164 66.75H50.5251L77.5813 32.4375C78.3501 31.4625 77.6563 30 76.4001 30H62.8063C61.8876 30 61.0251 30.4125 60.4438 31.1438L28.7938 71.2875C25.7001 75.225 28.4938 81 33.5001 81H164C164.825 81 165.5 80.325 165.5 79.5V68.25C165.5 67.425 164.825 66.75 164 66.75Z",
    fill: "url(#paint0_linear_402_4930)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_4930",
    x1: 96.4999,
    y1: 30,
    x2: 96.4999,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIconGreen);
export default __webpack_public_path__ + "static/media/arrows-icon-green.04b78a5a66623d858dd9daff7b77fc7b.svg";
export { ForwardRef as ReactComponent };